import React from 'react';
import { TiArrowRightThick } from 'react-icons/ti';
import { Button, Flex, Text, Icon } from '@chakra-ui/react';
import { moneyFormatter } from 'utils/formaters';
import { Card } from './Card';

interface InfoCardProps {
  title?: string;
  subtitle?: string;
  data: { value: number; percent: number };
  navigate?: string;
}

const InfoCard: React.FC<InfoCardProps> = ({
  title,
  subtitle,
  data,
  navigate = null,
}) => {
  const { value, percent } = data;

  return (
    <Card>
      <Flex justifyContent="space-between" mb={4} alignItems="center">
        <Text fontSize="sm" fontWeight={500} color="button" alignSelf="center">
          {title}
        </Text>

        {navigate && (
          <Button
            bg="grey.600"
            minW={0}
            minH={0}
            h="20px"
            w="20px"
            padding={0}
            borderRadius={999}
            fontSize={1}
            position="relative"
          >
            <Icon as={TiArrowRightThick} color="white.0" w={3} h={3} />
          </Button>
        )}
      </Flex>
      <Flex alignItems="center" mb={1}>
        <Text fontSize="md" fontWeight={500} mr={3}>
          {moneyFormatter(value)}
        </Text>
        <Text fontSize="10px" color={percent > 0 ? 'green.600' : 'red.200'}>
          {percent > 0 ? `+${percent}%` : `${percent}%`}
        </Text>
      </Flex>
      <Text fontSize="12px" color="grey.600" textAlign="left">
        {subtitle}
      </Text>
    </Card>
  );
};

export default InfoCard;
